<template>
  <nav
    v-if="user && !shared"
    class="navbar navbar-expand navbar-light bg-light"
  >
    <div class="container">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{name: 'profile'}"
          >
            Profile
          </router-link>
        </li>
        <li
          v-if="can('access-subscriptions')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'subscriptions'}"
          >
            Subscriptions
          </router-link>
        </li>
        <li
          v-if="can('access-health-data-scorecard')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'health-data'}"
          >
            Health Assessment
          </router-link>
        </li>
        <li
          v-if="can('access-health-data-scorecard')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'scorecard'}"
          >
            Scorecard
          </router-link>
        </li>
        <li
          v-if="can('access-individual-resources')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'resources'}"
          >
            Resources
          </router-link>
        </li>
        <li
          v-if="can('access-instructor-resources')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'instructor-resources'}"
          >
            Resources
          </router-link>
        </li>
        <li
          v-if="can('access-food-service-resources')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'food-service-resources'}"
          >
            Resources
          </router-link>
        </li>
        <li
          v-if="can('access-food-database')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'my-favorites'}"
          >
            Food Search
          </router-link>
        </li>
        <li
          v-if="can('access-food-tracker')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'food-tracker'}"
          >
            Food Tracker
          </router-link>
        </li>
        <li
          v-if="can('access-communications')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'communications'}"
          >
            Communications
          </router-link>
        </li>
        <li
          v-if="can('access-share-portal')"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :to="{name: 'share-portal'}"
          >
            Share Portal
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters('user', [
      'user',
      'authenticated',
      'shared',
    ]),
  }
}
</script>

<style scoped>
    .navbar-expand .navbar-nav {
        flex-wrap: wrap;
    }
</style>
